/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited
// @ts-nocheck


import { DEFAULT_SIZE, type IconProps } from '../../npmlib-icons/src/types';


export const ExpandY = ({ color = 'currentColor', size = DEFAULT_SIZE, ...props }: IconProps) => {
        return (
                <svg
                    width={size}
                    height={size}
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    {...props}>
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M17.9914 10.4081L12.0015 4.41819L6.01155 10.4081L5.02954 9.42609L11.0195 3.43618C11.5618 2.89383 12.4411 2.89383 12.9835 3.43618L18.9734 9.42609L17.9914 10.4081ZM6.06769 14.1115L12.0576 20.1014L18.0475 14.1115L19.0295 15.0935L13.0396 21.0834C12.4973 21.6257 11.6179 21.6257 11.0756 21.0834L5.08569 15.0935L6.06769 14.1115Z"
                        fill={color}
                    />
                </svg>
        );
    };
